<script>
export default {
  name: 'ReportsFiltersResolveBy',
  emits: ['resolveByFilterSelection'],
  data() {
    return {
      options: [
        { key: 'AI', label: 'AI', value: 'AI' },
        // { key: 'HP', label: 'HP', value: 'HP' },
        { key: 'In-house', label: 'In-house', value: 'In-house' },
      ],
      currentSelected: null,
    };
  },
  methods: {
    handleInput() {
      this.$emit('resolveByFilterSelection', this.currentSelected);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      multiple
      :close-on-select="false"
      :clear-on-select="false"
      hide-selected
      v-model="currentSelected"
      class="no-margin"
      :options="options"
      track-by="value"
      label="label"
      placeholder="Resolve By"
      :show-labels="false"
      @update:model-value="handleInput"
    />
  </div>
</template>
